'use client'

import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'
import Error from './error'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <html>
      <body>
        <Error error={error} reset={reset} />
      </body>
    </html>
  )
}
